import "./ToggleInput.scss";

import { FC, InputHTMLAttributes } from "react";

import c from "classnames";

interface IProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  checked: boolean;
  id?: string;
  dataTestId?: string;
  onChange?(event: IToggleInputEvent): void;
}

export interface IToggleInputEvent {
  target: {
    value: boolean;
    id: string;
  };
}

const ToggleInput: FC<IProps> = props => {
  const { checked, className, dataTestId, id, onChange = () => {}, ...restProps } = props;

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const changeEvent = {
      target: { id: event.target.id, value: event.target.checked },
    };
    onChange(changeEvent);
  };

  const classes = c("toggle__container", className);

  return (
    <label className={classes} data-testid={dataTestId}>
      <input
        {...restProps}
        checked={checked}
        className="toggle__input"
        data-testid="toggle__input"
        id={id}
        onChange={handleOnChange}
        type="checkbox"
      />
      <span className="toggle__slider" />
    </label>
  );
};

export default ToggleInput;
